import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CateringExcellence from './pages/catering-excellence';
import OurItalianStory from './pages/our-italian-story';
import MenuShowcase from './pages/menu-showcase';
import VisitConnect from './pages/visit-connect';
import GalleryReviews from './pages/gallery-reviews';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/catering-excellence" element={<CateringExcellence />} />
        <Route path="/our-italian-story" element={<OurItalianStory />} />
        <Route path="/menu-showcase" element={<MenuShowcase />} />
        <Route path="/visit-connect" element={<VisitConnect />} />
        <Route path="/gallery-reviews" element={<GalleryReviews />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
